module.exports = __webpack_public_path__ + "static/media/edna.0642502a.jpg";